// Dải nhắc "Lộ trình nâng cấp" ở trang Tổng quan (Shop / CTV) — chỉ hiện khi nhà phân phối có đặt chỉ tiêu cho loại
// đơn vị này. Đủ điều kiện → nổi bật, mời gửi yêu cầu; chưa đủ → tiến độ tháng này; đang chờ duyệt → trạng thái.

import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ArrowUpCircle, ChevronRight } from 'lucide-react'
import { get } from '@/lib/api'
import { cn } from '@/lib/utils'
import { useUnitCan } from '@/lib/unitAccess'
import { TO_LABEL, type UpgradeProgress } from './types'

export function UpgradeBanner({ className }: { className?: string }) {
  // Nâng cấp đơn vị là việc của chủ — nhân viên không thấy (docs/KE_HOACH_THANH_VIEN_DON_VI.md)
  const { isStaff } = useUnitCan()
  const q = useQuery({ queryKey: ['upgrade', 'progress'], queryFn: () => get<UpgradeProgress>('/upgrade/progress'), staleTime: 5 * 60_000, retry: false, enabled: !isStaff })
  const d = q.data
  if (isStaff || !d || (!d.directions.length && !d.pending)) return null
  const eligible = d.directions.filter((x) => x.eligibility?.status === 'eligible')
  let text: string
  if (d.pending) text = `Yêu cầu lên ${TO_LABEL[d.pending.data.toType]} đang chờ ${d.pending.data.approver === 'agency' ? d.pending.newParent.name : 'nhà phân phối'} duyệt.`
  else if (eligible.length) text = `Bạn đủ điều kiện lên ${eligible.map((x) => TO_LABEL[x.toType]).join(' hoặc ')}.`
  else {
    const best = d.directions
      .map((x) => ({ x, p: x.currentMonth.progress.reduce((m, p) => Math.min(m, p.pct), 100) }))
      .sort((a, b) => b.p - a.p)[0]!
    const first = best.x.currentMonth.progress[0]
    text = `Lên ${TO_LABEL[best.x.toType]}: ${first ? `${first.value.toLocaleString('vi-VN')}/${first.target.toLocaleString('vi-VN')} ${first.key === 'goodsValue' ? 'đ tiền hàng' : first.key === 'activeChildren' ? 'Shop có đơn' : 'đơn giao'} tháng này` : 'xem chỉ tiêu'}.`
  }
  return (
    <Link
      to="/upgrade"
      className={cn(
        'flex items-center gap-3 rounded-xl px-4 py-3 text-sm transition-colors',
        eligible.length && !d.pending ? 'bg-accent text-onAccent hover:bg-accentSoft' : 'bg-raise text-ink shadow-card hover:bg-paperSoft dark:border dark:border-rule',
        className,
      )}
    >
      <ArrowUpCircle className="size-5 shrink-0" />
      <span className="min-w-0 flex-1">{text}</span>
      <ChevronRight className="size-4 shrink-0 opacity-70" />
    </Link>
  )
}
